import React, { Component } from "react";
import platform from "Pub/js/platform";
import Ifr from "../../pages/ifr";
import MicroApp from "../../pages/ifr/microapp";
import './index.less'
import { Dropdown } from 'antd';
import dropIcon from '../../assets/images/drop.svg';
import { sessionStorageUtil, setStore, getStore } from "Pub/js/storageUtils";
import { GetQuery, langCheck, setUrlInSession, cacheURL, checkWindowClosable, isInsideTab, getAutoFlag } from "Pub/js/utils";
import { getMulti } from "Pub/js/getMulti";
const { PubSub, promptBox } = platform;
const { NCTooltip, NCLoading, NCDropdown, NCDnd } = platform.base;
import { openNewPage, getAbsoluteUrl } from "Pub/js/superJump";
import { NoNeedWatermarkRoutes, routes } from "../../routes";
import AllAppBtn from "../../layout/headerComponents/AllAppBtn";
import { globalHotKeys } from "Pub/js/globalHotKeys";
import pubSubActions from "Pub/js/pubSubActions";

let maxTabsNum = 15; // 暂定15
const maxCacheCount = 15;
const getHomeTab = () => {
    return {
        name: '',
        hash: '#/',
        key: 'home',
        appKey: 'home'
    }
}

// const codeMap = {
//     '50090404': 'DG2226329523840352273',
//     '50080404': 'DG2231470410714578947',
//     '38302844': 'DG2231429720172920832',
//     '38302832': 'DG2229765669472174089',
//     '400413206': 'DG2226276111621816330',
//     '400612000': 'DG2231253480493809665',
//     '200400ARS': 'DG2226272228971380740',
//     '200401APS': 'DG2231431704447811590',
//     '182012008A': 'DG2224785010652610560',
//     '201204504A': 'DG2230823236439900165',
//     '20023005': 'DG2235886916989354003'
// };

class BrowserTab extends Component {
    constructor(props) {
        super(props);
        const homeTab = getHomeTab();
        const newTabInfo = getStore('newTabInfo');
        let existedTabs;
        if (newTabInfo) {
            if (newTabInfo.NCCSessionStorage) {
                window.NCCSessionStorage[newTabInfo.appKey] = newTabInfo.NCCSessionStorage;
            }
            delete newTabInfo.NCCSessionStorage; // 中转用的，用完删除
            existedTabs = {
                actived: 1,
                browserTabs: [homeTab, newTabInfo]
            }
            localStorage.removeItem('newTabInfo');
        } else {
            existedTabs = sessionStorageUtil.getItem('browserTabs');
            // 取出数据之后从缓存删除，缓存只是为了解决刷新不丢失数据
            // 如果不删除，用户由浏览器页签切换成内部页签，会莫名多出页签数据
            sessionStorage.removeItem('browserTabs');
        }
        let currentActived = ((existedTabs || {}).actived) || 0; // 默认是首页
        const querys = GetQuery(props.location.search);
        this.isDesign = Boolean(querys.workbenchid) || querys.editable; // 工作台管理节点进来的（设计or预览）
        if (this.isDesign) {
            currentActived = 0;
        } else {
            if (this.props.location.pathname === '/' && currentActived === 0 && location.hash !== homeTab.hash) {
                // 异常情况导致网页崩溃，刷新之后可能丢失所有的页签数据，激活首页顺便改一下hash
                location.hash = homeTab.hash;
            }
        }
        const browserTabs = (existedTabs || {}).browserTabs || [homeTab];
        this.state = {
            browserTabs,
            actived: currentActived, // 默认是首页
            onModalOk: undefined, //弹窗点击确定按钮触发的函数
            isFullScreen: false,
            visible: false,   //下拉框显示隐藏
            activeTabs: new Set([browserTabs[currentActived].key]), // 存储需要render的页签。处理刷新时所有iframe都重新加载的问题，会导致非激活页签取不到对应的appcode(url取appcode)
            loading: false, //iframe 加载时需要loading状态
            json: {},//多语
            tabContextMenuIndex: null, // 右键菜单所在页签的数据索引
            tabHoveredIndex: null, // 鼠标所在页签的数据索引
            microTempDataMap: {}, // 微应用临时数据存储映射
            tabDragging: false,
        }
        this.tabRefs = [];
        this.lastTabActived = null;
        // this.windowClose = window.top.close; // 存储原本的window.top.close方法
        props.onTabChange('tabActived', this.state.actived);
        this.autoFlag = getAutoFlag();
    }

    componentDidMount() {
        const { browserTabs } = this.state;
        // 先不重写了，工作台设计器已改成永远浏览器页签打开，如果后续有需求再放开，但是要考虑一个问题（工作台设计器是浏览器页签，所以调用close是要关掉浏览器页签的，可能得有这么一个逻辑：当前内部页签激活的是首页且仅有一个首页，那么直接close掉，或者怎么能让打开浏览器页签的不走内部页签模式）
        // if (!window.top.newClose) { // 已经重写过就不管了，场景是工作台设计器，内外两层都是工作桌面
        //     window.top.close = window.top.newClose = () => { // 重写close方法，兼容节点内部通过top.close的方式关闭页签
        //         this.closeTab(this.state.actived)
        //     }
        // }
        //监听全屏
        document.addEventListener('fullscreenchange', this.handleFullScreenChange)
        window.addEventListener('beforeunload', this.handlePageReload)
        window.addEventListener('unload', this.handleUnload);
        let scrollArea = ReactDOM.findDOMNode(this).querySelector('.tab-left')
        scrollArea.addEventListener('wheel', this.handleTabScroll)
        //挂载多语
        let callback = json => {
            browserTabs[0].name = langCheck("browserTabs-000000", true, json) /* 国际化处理： 首页*/
            this.setState({
                browserTabs,
                json,
            })
        };
        getMulti({
            moduleId: "browserTabs",
            domainName: "workbench",
            callback
        });

        //打开新页签触发
        PubSub.subscribe('OpenTab', (action, { tabInfo, inNewTab, tabConfig }) => {
            this.lastTabActived = null;
            if (inNewTab) {
                this.openInNewTab(tabInfo);
            } else {
                this.openTab(tabInfo, tabConfig);
            }
        });

        PubSub.subscribe('OpenPage', (action, pageUrl) => { // 打开workbench路由页面
            const { actived } = this.state;
            this.lastTabActived = actived !== 0 ? actived : null;
            this.updateActived({ index: 0, key: 'home' });
            this.closeMenuSider();
        })
        PubSub.subscribe('changeInsideTabActived', () => {
            this.handleTabClick(0); // 目前仅支持激活首页，后续可通过参数扩展
        })
        window.findAppInBrowserTabs = this.findAppInBrowserTabs;
        window.microAppApi = {
            close: this.handleCloseByAppkey
        }
        this.insideTabChange = document.createEvent('Event');
        this.insideTabChange.initEvent("insideTabChange", false, true);
        globalHotKeys.bind(hotkeys => hotkeys.INSIDETABCLOSE, this.handleHotKeyTabClose);

        this.iframeClickPubSub = PubSub.subscribe(pubSubActions.global.onIframeClick, () => {
            this.state.visible && this.handleDropDownChange();
        });
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.location.pathname != nextProps.location.pathname) { // 监听路由变化
            if (nextProps.location.pathname === '/') { // 处理工作桌面从其他页面返回首页时上次的页签激活状态
                let { browserTabs, activeTabs } = this.state;
                if (this.lastTabActived !== null) {
                    activeTabs.delete('home');
                    this.setState({
                        actived: this.lastTabActived
                    })
                    location.hash = browserTabs[this.lastTabActived].hash;
                    this.lastTabActived = null; // 置空
                }
            }
        }
    }

    componentDidUpdate(prevProps, prevState) {
        const { actived } = this.state;
        if (actived !== prevState.actived) {
            this.props.onTabChange('tabActived', actived);
            if (actived) {
                const activedIframe = this.getIframeByIndex(actived);
                activedIframe && activedIframe.focus();
            }
        }
    }

    componentWillUnmount() {
        // window.top.close = this.windowClose;
        PubSub.unsubscribe('OpenTab');
        PubSub.unsubscribe('OpenPage');
        PubSub.unsubscribe('changeInsideTabActived');
        PubSub.unsubscribe(this.iframeClickPubSub);
        document.removeEventListener('fullscreenchange', this.handleFullScreenChange)
        window.removeEventListener('beforeunload', this.handlePageReload)
        window.removeEventListener('unload', this.handleUnload);
        let scrollArea = ReactDOM.findDOMNode(this).querySelector('.tab-left')
        scrollArea.removeEventListener('wheel', this.handleTabScroll)
        globalHotKeys.remove(hotkeys => hotkeys.INSIDETABCLOSE, this.handleHotKeyTabClose);
        if (!isInsideTab()) {
            const { actived, browserTabs } = this.state;
            // 内部页签切换为浏览器页签，如果激活的不是首页，更改一下
            if (actived) {
                location.hash = browserTabs[0].hash;
            }
        }
    }

    handleHotKeyTabClose = () => {
        const { actived } = this.state;
        if (actived !== 0) {
            this.handleTabClose(null, actived);
        }
    }

    // reload 定位之后是否重载
    findAppInBrowserTabs = (appKey, reload) => {
        const { browserTabs } = this.state;
        const existedTabIndex = browserTabs.findIndex(item => item.appKey === appKey);
        if (existedTabIndex !== -1) {
            this.closeMenuSider();
            this.handleTabClick(existedTabIndex, true, reload);
            return true;
        }
    }

    openTab = (tab, tabConfig = {}) => {
        let { browserTabs, actived } = this.state;
        const { alertMsg } = this.props;
        this.closeMenuSider();
        if (tab.openType === 'link') { // linkTo替换
            const linkIndex = browserTabs.findIndex(item => item.key === tab.key);
            if (linkIndex !== -1) {
                const { sort } = browserTabs[linkIndex];
                if (actived === linkIndex) { // 处于激活状态
                    location.hash = tab.hash;
                }
                browserTabs[linkIndex] = { ...tab, sort }; // sort保持不变
                this.setState({
                    browserTabs
                })
            }
            return;
        }

        const isMaxCount = browserTabs.length >= maxTabsNum;
        if (!isMaxCount) { // 超过最大数量不更新，因为要打开新的浏览器页签了
            location.hash = tab.hash;
        }
        let openedIndex = browserTabs.findIndex(item => item.key === tab.key);  // 如果标签已经打开过，记录index
        if (openedIndex !== -1) { // 定位
            this.handleTabClick(openedIndex)
        } else {
            if (isMaxCount) {  // 标签数量大于maxTabsNum时，弹窗提示
                this.handleModalShow(() => {
                    this.openInNewTab(tab);
                });
                return
            }

            const handleOpenTab = () => {
                if (tab.crossTabData) { // 跨页签数据
                    window.AppCrossTabData[tab.appKey] = tab.crossTabData;
                }
                const currentAppSesstionStorage = window.NCCSessionStorage[browserTabs[actived].appKey];
                if (currentAppSesstionStorage) { // 将当前应用的带给下个应用
                    window.NCCSessionStorage[tab.appKey] = _.cloneDeep(currentAppSesstionStorage);
                }

                // 处理打开时的页签顺序
                let { sortIndex } = tabConfig;
                const { sortTabs } = this.getSortTabs();
                if (sortIndex === undefined) { // 自动化环境默认排在最后，非自动化环境默认排在激活页签后面
                    sortIndex = this.autoFlag ? sortTabs.length : sortTabs.findIndex(item => item.index === actived) + 1;
                }
                tab.sort = sortIndex;
                sortTabs.forEach((item, index) => {
                    browserTabs[item.index].sort = index < sortIndex ? index : index + 1;
                })

                browserTabs.push(tab);
                this.updateActived({ index: browserTabs.length - 1, key: tab.key }, { browserTabs }, () => {
                    // top.qiankun_start_time = performance.now();
                    // 若打开页签超出屏幕外，要把这个页签滑动到可视范围内
                    const viewsTab = document.querySelector(`.tab${browserTabs.length - 1}`);
                    viewsTab.scrollIntoView();
                });
            }

            if (tab.microType === 'component') {
                // 组件类型的延迟，组件内部可能有用到路由的location.search，hash改变之后不能及时响应，需要延迟
                setTimeout(() => {
                    handleOpenTab();
                })
            } else {
                handleOpenTab();
            }
            
            //打开新节点检查此节点是否需要预警
            setTimeout(() => { alertMsg() }, 200) //hash的改变在延时器里，所以这里也要放在延时器中
        }
    }

    // 关闭菜单弹窗
    closeMenuSider = () => {
        this.props.closeAllApp();
    }

    // 刷新
    handlePageReload = async (e) => {
        const { browserTabs } = this.state;
        let enableClose = true;
        for (let i = 1; i < browserTabs.length; i++) {
            const canUnload = await this.canUnload({ index: i, showTip: false });
            if (!canUnload) {
                enableClose = false;
                break;
            }
        }
        if (!enableClose) {
            e.returnValue = langCheck("browserTabs-000004", true, this.state.json);
        }
    }

    handleUnload = () => {
        // 存一下，刷新之后不丢失页签数据
        const { actived, browserTabs } = this.state;
        if (sessionStorage.getItem('noCacheBrowserTabs')) { // 切换集团导致的刷新，所有页签数据不保留
            sessionStorage.removeItem('noCacheBrowserTabs');
        } else {
            sessionStorageUtil.setItem('browserTabs', {
                actived: actived,
                browserTabs: browserTabs
            })
        }
    }

    handleTabScroll = (e) => {
        let scrollArea = ReactDOM.findDOMNode(this).querySelector('.tab-left')
        e.preventDefault();
        scrollArea.scrollBy({
            left: (e.deltaY < 0 || e.deltaX > 0) ? -20 : 20,
            behavior: "smooth"
        });
    }

    handleModalShow = (callback) => {
        promptBox({
            color: 'warning',
            title: langCheck("browserTabs-000001", true, this.state.json) /* 国际化处理：页签超出上限*/,
            content: langCheck("browserTabs-000002", true, this.state.json, [maxTabsNum]),
            // beSureBtnClick: callback,
            noCancelBtn: true,
            container: document.body,
            closeByClickBackDrop: false,
            wrapClassName: 'intercept-prompt-box'
        })
    }

    // 在新的浏览器页签中打开
    openInNewTab = tab => {
        const { browserTabs, actived } = this.state;
        setStore('newTabInfo', { ...tab, NCCSessionStorage: window.NCCSessionStorage[browserTabs[actived].appKey] });
        openNewPage(window, getAbsoluteUrl(tab.hash), tab.key, null, tab.crossTabData);
    }

    handleFullScreenChange = () => {
        if (document.fullscreenElement === document.documentElement) {  // 处于全屏
            this.setState({
                isFullScreen: true
            })
        } else {
            this.setState({
                isFullScreen: false
            })
        }
    }

    // 刷新
    reload = async (index, tab) => {
        const { browserTabs, activeTabs } = this.state;
        if (tab.microType === 'component') {
            // browserTabs[index].time = Date.now();
            // this.setState({ browserTabs });
            // 利用时间改变key，让组件重载会有点问题（YBP-RIA-BUG-14750），原因未知
            // 通过更改激活状态，让组件先卸载，再挂载
            let activeArr = Array.from(activeTabs);
            const tabIndex = activeArr.findIndex(item => item === tab.key);
            if (tabIndex !== -1) {
                activeArr.splice(tabIndex, 1);
                this.setState({
                    activeTabs: new Set(activeArr)
                }, () => {
                    activeArr.splice(tabIndex, 0, tab.key);
                    this.setState({
                        activeTabs: new Set(activeArr)
                    });
                });
            }
            return;
        }
        if (['qiankun', 'iframe'].includes(tab.microType)) {
            this.tabRefs[index].refresh(() => {
                this.props.onTabRefresh();
            }, () => {
                this.props.alertMsg();
            });
            return;
        }
    }
    // 新页签打开
    openNewTab = (index) => {
        let { browserTabs } = this.state;
        const curTab = browserTabs[index];

        const { microType, initAppData, mapDataFn } = curTab;
        const { pagecode } = initAppData;
        const tabConfig = { sortIndex: curTab.sort + 1 };
        if (microType === "component" || pagecode === '102202SANDBOX_PREW') {
            // 设计器页面的预览直接复制一套出来，如果采用应用编码打开，会有很多数据获取不到（打开预览时传的一些参数）
            let newTab = _.cloneDeep(curTab);
            const oldAppKey = newTab.appKey;
            const newAppKey = Date.now();
            newTab.key = newTab.appKey = newTab.time = newAppKey;
            newTab.hash = `#/?page=${newAppKey}`;
            newTab.openType = null;
            setUrlInSession(newAppKey, cacheURL.getURL()[oldAppKey]);
            this.openTab(newTab, tabConfig);
        } else {
            // 打开当前页签初始应用的默认页面
            const { appcode, menuitemcode } = initAppData;
            window.openNew({
                appcode,
                menuitemcode
            }, null, null, {
                mapDataFn,
                funcParams: {
                    unique: true,
                    tabConfig,
                }
            });
        }
    }

    // 关闭右侧
    handleCloseRight = (sortIndex) => {
        const { browserTabs, actived } = this.state;
        const { sortTabs } = this.getSortTabs();
        const closeRight = () => {
            let nextActivedKey = browserTabs[actived].key; // 关闭之后需要激活页签的key
            sortTabs.forEach((item, idx) => {
                if (idx > sortIndex) {
                    this.delGlobalDataByKey(browserTabs[item.index].key);
                    browserTabs[item.index].isDelete = true; // 标记一下要删除的
                    if (item.key === nextActivedKey) { // 激活的在删除范围内，更改
                        nextActivedKey = sortTabs[sortIndex].key;
                    }
                }
            })
            _.remove(browserTabs, item => item.isDelete); // 移除
            this.setState({
                browserTabs
            }, () => {
                this.handleTabClick(browserTabs.findIndex(item => item.key === nextActivedKey), false);
            })
        }
        this.handleBatchClose(targetIndex => {
            const targetSortIndex = sortTabs.findIndex(item => item.index === targetIndex);
            return targetSortIndex > sortIndex;
        }, closeRight);
    }

    handleBatchClose = async (checkFunc, callback) => {
        const { browserTabs } = this.state;
        for (let i = 0; i < browserTabs.length; i++) {
            if (checkFunc(i)) {
                /* 国际化处理：当前有页面处于编辑态，确定要退出吗？*/
                const canUnload = await this.canUnload(
                    { index: i, tipContent: langCheck("browserTabs-000004", true, this.state.json) },
                    forceClose => {
                        if (forceClose) { // 提示过后的强制关闭
                            callback();
                        }
                    }
                );
                if (!canUnload) {
                    return;
                }
            }
        }
        callback(); // 没有提示的关闭
    }

    // 关闭其他
    handleCloseOther = (index) => {
        const { browserTabs } = this.state;
        const closeOther = () => {
            browserTabs.forEach((tab, idx) => {
                if (![0, index].includes(idx)) {
                    this.delGlobalDataByKey(tab.key);
                }
            })
            this.setState({
                browserTabs: [browserTabs[0], browserTabs[index]]
            }, () => {
                this.handleTabClick(1, false);
            })
        }
        this.handleBatchClose(targetIndex => targetIndex !== index && targetIndex !== 0, closeOther);
    }

    // 是否可以卸载
    canUnload = async ({ index, showTip = true, tipTitle, tipContent, locateTo = false }, callback = () => {}) => {
        // callback(true/false) // 是否是提示过后的强制关闭
        const title = tipTitle || langCheck("browserTabs-000003", true, this.state.json); /* 国际化处理：退出提示*/
        const content = tipContent || langCheck("browserTabs-000005", true, this.state.json); /* 国际化处理：当前页面不会保存，确定要离开吗？*/
        try { // 检查是否可关闭是领域代码，可能会报错
            const closeable = await this.tabRefs[index].checkClosable();
            if (!closeable) {
                if (locateTo) { // 定位到当前页签
                    this.handleTabClick(index);
                }
                showTip && promptBox({
                    color: 'warning',
                    title,
                    content,
                    beSureBtnClick: () => {
                        callback(true);
                    },
                    container: document.body,
                    // 不允许点背景关闭，platform的计数有问题，如果点背景关闭了，会导致之后该组件的确定回调顺序混乱
                    closeByClickBackDrop: false,
                    wrapClassName: 'intercept-prompt-box'
                })
                return false;
            } else {
                callback(false);
            }
        } catch (error) {
            callback(false);
        }
        return true;
    }

    handleCloseByAppkey = (appKey) => {
        const { browserTabs } = this.state;
        const appTabIndex = browserTabs.findIndex(item => item.appKey === appKey);
        if (appTabIndex !== -1) {
            this.handleTabClose(null, appTabIndex);
        }
    }

    // 关闭
    handleTabClose = (e, index) => {
        e && e.stopPropagation();
        this.canUnload({ index, locateTo: true }, () => {
            this.closeTab(index);
        })
    }
    closeTab = (index) => {
        try {
            let ifr = (this.getIframeByIndex(index) || {}).contentWindow;
            if (ifr && ifr.insideTabClose) { // 内部页签关闭时提供给领域的回调
                ifr.insideTabClose()
            }
        } catch(err) {}
        let { browserTabs, actived } = this.state
        const { sortTabs } = this.getSortTabs();
        const sortIndex = sortTabs.findIndex(item => item.index === index);
        let nextActivedKey = browserTabs[actived].key; // 关闭之后需要激活页签的key
        if (index === actived) { // 关闭的是当前激活的，激活左侧
            if (sortIndex === 0) {
                nextActivedKey = 'home';
            } else {
                nextActivedKey = sortTabs[sortIndex - 1].key;
            }
        }
        this.delGlobalDataByKey(browserTabs[index].key);
        browserTabs.splice(index, 1);
        this.setState({
            browserTabs,
        }, () => {
            this.handleTabClick(browserTabs.findIndex(item => item.key === nextActivedKey), false);
        })

    }

    getIframeByIndex = index => {
        return this.tabRefs[index] && this.tabRefs[index].getIframeNode && this.tabRefs[index].getIframeNode();
    }

    delGlobalDataByKey = tabKey => {
        delete window.globalDataPool[tabKey];
    }

    handleTabClick = (index, message = true, reload = false) => {
        let { browserTabs, actived } = this.state;
        if (actived === index) { return; }

        let tab = browserTabs[index]
        let targetTab = ReactDOM.findDOMNode(this).querySelector(`.tab${index}`)
        targetTab.scrollIntoView(({ inline: "center" }));
        location.hash = tab.hash; // 更新hash
        this.updateActived({ index, key: tab.key }, {}, () => {
            if (message) { // 仅针对页签切换（不包含页签关闭导致的改变），通知platform
                this.insideTabChange.data = {
                    inactiveKey: browserTabs[actived].appKey,
                    activeKey: browserTabs[index].appKey,
                    activeTab: browserTabs[index],
                }
                window.dispatchEvent(this.insideTabChange);
            }
            if (reload) {
                setTimeout(() => {
                    this.reload(index, tab);
                })
            }
        });
    }

    updateActived = ({ index, key }, others = {}, callback = () => {}) => {
        let { activeTabs, browserTabs } = this.state;
        const tabKeys = Array.from(activeTabs);
        tabKeys.forEach(k => {
            if (!browserTabs.find(item => item.key === k)) {
                activeTabs.delete(k); // 移除已经关闭页签的激活状态
            }
        })
        // 这里先删再加是为了更新顺序，最新激活的排在最后
        activeTabs.delete(key);
        activeTabs.add(key);
        if (activeTabs.size > maxCacheCount) {
            const tabsArr = Array.from(activeTabs);
            // 保留最近激活
            activeTabs = new Set(tabsArr.slice(tabsArr.length - maxCacheCount));
        }
        // console.log('nowActiveTabs', activeTabs, Array.from(activeTabs).map(item => {
        //     const tab = this.state.browserTabs.find(ite => ite.key === item);
        //     return tab && tab.name;
        // }));
        this.setState({
            actived: index,
            activeTabs,
            ...others
        }, callback)
    }

    handleDropDownChange = () => {
        this.setState({
            visible: !this.state.visible
        })
    }
    
    //切换全屏函数
    toggleFullScreen = () => {
        const { isFullScreen } = this.state;
        if (isFullScreen) {
            document.exitFullscreen();
        } else {
            document.documentElement.requestFullscreen();
        }
    }

    //桌面配置
    handleEditDesktop = () => {
        PubSub.publish('editDesktop')
    }
    // iframe 加载前后的loading状态控制
    handleLoadingChange = (isLoading) => {
        this.setState({
            loading: isLoading
        })
    }

    handleUpdateTabName = (index, name) => {
        const { browserTabs } = this.state;
        browserTabs[index].name = name;
        this.setState({
            browserTabs
        });
    }

    renderTab = (tab, index) => {
        let { actived, tabContextMenuIndex, tabHoveredIndex } = this.state;
        return <NCTooltip
            visible={!this.autoFlag && tabHoveredIndex === index && tabContextMenuIndex === null}
            overlay={tab.name}
            placement="bottom"
        >
            <span
                fieldid={`microapp-tab${index === actived ? '-actived' : ''}`}
                className={index === actived ? "tab-wrapper-actived" : "tab-wrapper"}
            >
                <span className="tab-text">{tab.name}</span>
                <span
                    className="tab-close icon iconfont icon-shenpibohui"
                    onClick={(e) => {
                        this.resetHoveredIndex();
                        this.handleTabClose(e, index)
                    }}
                >
                </span>
            </span>
        </NCTooltip>
    }

    getMicroInfo = tab => {
        const { browserTabs } = this.state;
        let microInfo = {
            component: null,
            props: {} // 针对不同微应用类型的props
        }
        if (tab.microType === 'component') {
            microInfo.component = routes.find(item => item.path === tab.ifr).syncComponent;
            microInfo.props = {
                hideBackBtn: true, // 工作桌面内部路由页面隐藏返回按钮
                rootInstance: this.props.rootInstance,
                location: this.props.location, // 路由location，组件类型的页面原本是基于路由的，传下去
            }
        } else {
            const microComponentMap = {
                'iframe': Ifr,
                'qiankun': MicroApp
            };
            microInfo.component = microComponentMap[tab.microType];
            if (tab.microType === 'iframe') {
                microInfo.props = {
                    isInsideTab: browserTabs.length <= maxTabsNum ? true : false,
                    onLoadingChange: this.handleLoadingChange
                }
            }
        }
        return microInfo;
    }

    renderTabContent = () => {
        let { browserTabs, actived, activeTabs } = this.state
        let isActived = (tabKey) => {
            return Array.from(activeTabs).includes(tabKey);
        }
        const querys = GetQuery(location.hash);
        return browserTabs.map((tab, index) => {
            const { component: AppComponent, props: appProps } = this.getMicroInfo(tab);
            const tabVisible = index === actived;
            return this.props.renderWatermark({
                children: <div
                    className={`${tab.key === 'home' ? 'nc-workbench-container' : 'nc-iframe-container'} inside-iframe`}
                    fieldid={`microapp-content${tabVisible ? '-actived' : ''}`}
                >
                    {
                        isActived(tab.key)
                        ?
                            tab.key !== 'home'
                            ?
                            <MemoComponent
                                appComponent={AppComponent}
                                onRef={ref => this.tabRefs[index] = ref}
                                key={tab.appKey}
                                tabKey={tab.key}
                                appKey={tab.appKey}
                                hash={tab.hash}
                                visible={tabVisible}
                                onTabClose={() => { this.handleTabClose(null, index) }}
                                canUnload={cb => { this.canUnload({ index, locateTo: true }, cb) }}
                                updateTabName={name => { this.handleUpdateTabName(index, name) }}
                                onAppUnload={() => { this.handleOnAppUnload(tab.appKey) }}
                                {...appProps}
                            />
                            :
                            <div className='nc_workbench-container-content'>
                                <MemoChildren { ...this.props } />
                            </div>
                        :
                        null
                    }
                </div>,
                appcode: tab.key === 'home' ? querys.c : tab.appcode, // 如果是首页可能对应的是工作桌面内部不同的路由页面，需要动态取数据
                key: `${tab.key}-${tab.time}`,
                style: {
                    // visibility: index === actived ? 'visible' : 'hidden',
                    // opacity: index === actived ? 1 : 0
                    // 这块儿用display控制显隐，不然随着页签的增多，dom将会越来越多，操作会变卡，国产化系统尤为明显
                    display: tabVisible ? 'block' : 'none'
                },
                // 需要水印的路由页面
                enable: this.getMicroWatermarkEnable(tab)
            })
        })

    }

    getMicroWatermarkEnable = (tab) => {
        const { microTempDataMap } = this.state;
        const tempData = microTempDataMap[tab.appKey];
        if (tempData && tempData.hasOwnProperty('watermark')) {
            return tempData.watermark.enable;
        }
        if (tab.ifr) {
            const ifrQuerys = GetQuery(tab.ifr);
            if (ifrQuerys.noWatermark === 'true') { // 适用于通过openTo打开节点不想要水印
                return false;
            }
        }
        return !NoNeedWatermarkRoutes.includes(tab.ifr);
    }

    handleOnAppUnload = (appKey) => {
        const { microTempDataMap } = this.state;
        delete microTempDataMap[appKey];
        this.setState({ microTempDataMap });
        delete window.AppCrossTabData[appKey];
    }

    getTabNavVisible = () => {
        if (this.isDesign || this.props.location.pathname !== "/") {
            return false;
        }
        return !this.props.hideNav;
    }

    handleDragStart = () => {
        this.setState({
            tabContextMenuIndex: null,
            tabDragging: true
        })
    }

    handleDragStop = (result, items) => {
        const { browserTabs } = this.state;
        items.forEach((item, index) => {
            // 现功能有很多依赖于索引的地方，新加sort用于排序，不改变原数组的顺序，代价最小
            browserTabs[item.props.index].sort = index;
        })
        this.setState({
            browserTabs,
            tabDragging: false
        });
    }

    getSortTabs = () => {
        const { browserTabs } = this.state;
        const homeIndex = browserTabs.findIndex(item => item.key === 'home');
        const indexTabs = browserTabs.map((item, index) => {
            return {
                ...item,
                index
            }
        })
        const homeTab = indexTabs.splice(homeIndex, 1).pop();
        return {
            homeTab,
            sortTabs: _.sortBy(indexTabs, 'sort'),
        };
    }

    // 处理右键菜单内操作
    handleContextMenu = (type, sortIndex, tab) => {
        this.setState({
            tabContextMenuIndex: null,
            tabHoveredIndex: null
        });
        const { index } = tab;
        switch (type) {
            case 'reload': // 刷新
                this.reload(index, tab);
                break;
            case 'newTab': // 新页签打开
                this.openNewTab(index);
                break;
            case 'closeRight': // 关闭右侧
                this.handleCloseRight(sortIndex);
                break;
            case 'closeOther': // 关闭其他
                this.handleCloseOther(index);
                break;
        }
    }

    resetHoveredIndex = () => {
        clearTimeout(this.tabEnterTimer);
        this.setState({ tabHoveredIndex: null });
    }

    // 目前用于更新水印显示or隐藏、更新页签标题
    updateMicroOnMain = (upData, appKey) => {
        // upData:
        // { type: 'watermark', data: { enable: false/true } }
        // { type: 'tabTitle', data: '页签标题' }
        const { type, data } = upData;
        if (type === 'tabTitle') {
            const { browserTabs } = this.state;
            const appTab = browserTabs.find(item => item.appKey === appKey);
            if (appTab) {
                appTab.name = data;
                this.setState({ browserTabs });
            }
        } else {
            const { microTempDataMap } = this.state;
            const oldData = microTempDataMap[appKey] || {};
            microTempDataMap[appKey] = { ...oldData, [type]: data };
            this.setState({
                microTempDataMap
            })
        }
    }

    enableOpenNewTab = (tab) => {
        // 1. 工作桌面内部页面不支持新页签打开，采用redux存储数据，然后又是组件模式直接加载，同时存在多个页签可能会导致数据混乱
        // 2. 没有应用编码的，无法打开
        if (tab.microType === 'component' || !tab.initAppData.appcode) {
            return false;
        }
        return true;
    }

    render() {
        let { actived, isFullScreen, visible, tabContextMenuIndex, tabDragging } = this.state;
        const { onTabChange, navShow, changeAllApp } = this.props;
        const { homeTab, sortTabs } = this.getSortTabs();
        return <React.Fragment>
            <div className="inside-tabs-nav" style={{ display: this.getTabNavVisible() ? 'flex' : 'none' }}>
                {
                    !navShow && <React.Fragment>
                        <AllAppBtn onInsideNav={true} onAllAppClick={changeAllApp} />
                        <span className="app-btn-line"></span>
                    </React.Fragment>
                }
                <NCTooltip
                    overlay={this.autoFlag ? '' : homeTab.name}
                    placement="bottom"
                >
                    <span
                        fieldid={`multi-tab-${homeTab.name}`}
                        onClick={() => this.handleTabClick(0)}
                        className={`${0 === actived ? "home-actived " : "home"} tab0 tab-common ${sortTabs.length ? 'tab-split-line' : ''}`}
                    >
                        <span fieldid={`microapp-tab${0 === actived ? '-actived' : ''}`} className="tab-home-content tab-text">
                            <i className="icon iconfont icon-shouye home-icon" />
                            {homeTab.name}
                        </span>
                    </span>
                </NCTooltip>
                <div
                    fieldid="other-tabs"
                    className="tab-left"
                >
                    {sortTabs.length ? <NCDnd
                        tabIndex={-1} // YBP-CCF-BUG-1736
                        type='horizontal'
                        dragingClass="tab-dragging"
                        onStart={this.handleDragStart}
                        onStop={this.handleDragStop}
                        list={sortTabs.map((tab, sortIndex) => {
                            const { index } = tab;
                            const contextMenuArg = [sortIndex, tab];
                            return <span
                                fieldid={`multi-tab-${tab.name}`}
                                className={`tab${index} tab-common ${sortIndex === sortTabs.length - 1 ? '' : 'tab-split-line'}`}
                                onClick={() => this.handleTabClick(index)}
                                index={index} // 拖拽之后会取这个index
                                onMouseEnter={() => {
                                    // 延迟，保持和默认的一致
                                    this.tabEnterTimer = setTimeout(() => {
                                        this.setState({ tabHoveredIndex: index })
                                    }, 500)
                                }}
                                onMouseLeave={this.resetHoveredIndex}
                            >
                                <Dropdown
                                    trigger="contextMenu"
                                    destroyPopupOnHide={true}
                                    visible={tabContextMenuIndex === index}
                                    onVisibleChange={val => { this.setState({ tabContextMenuIndex: val ? index : null }) }}
                                    // 阻止冒泡，不然会执行 handleTabClick
                                    overlay={<div className="tab-dropdown" onClick={e => e.stopPropagation()}>
                                        <span onClick={() => this.handleContextMenu('reload', ...contextMenuArg)}>
                                            {langCheck("browserTabs-000006", true, this.state.json)}{ /* 国际化处理： 刷新*/}
                                        </span>
                                        {
                                            this.enableOpenNewTab(tab) && <span onClick={() => this.handleContextMenu('newTab', ...contextMenuArg)}>
                                                {langCheck("browserTabs-000007", true, this.state.json)}{ /* 国际化处理： 新页签打开*/}
                                            </span>
                                        }
                                        <span onClick={() => this.handleContextMenu('closeRight', ...contextMenuArg)}>
                                            {langCheck("browserTabs-000008", true, this.state.json)}{ /* 国际化处理：关闭右侧*/}
                                        </span>
                                        <span onClick={() => this.handleContextMenu('closeOther', ...contextMenuArg)}>
                                            {langCheck("browserTabs-000009", true, this.state.json)}{ /* 国际化处理： 关闭其他*/}
                                        </span>
                                    </div>}
                                    animation="slide-up"
                                    overlayClassName="tab-panel-wrapper"
                                >
                                    {this.renderTab(tab, index)}
                                </Dropdown>
                            </span>
                        })} 
                    /> : null}
                </div>

                <div className="tab-right">
                    <NCDropdown
                        getPopupContainer={() => document.body}
                        trigger="click"
                        visible={visible}
                        onVisibleChange={this.handleDropDownChange}
                        animation="slide-up"
                        className="drop-down-container tab-split-line"
                        overlay={<div className="dropdown-panel-wrapper" onClickCapture={this.handleDropDownChange}>
                            {[homeTab, ...sortTabs].map(tab => {
                                const { index } = tab;
                                return <NCTooltip
                                    placement="bottom"
                                    overlay={tab.name}
                                >
                                    <div
                                        index={tab.key}
                                        className="panel-item"
                                        onClick={() => this.handleTabClick(index)}
                                    >
                                        <span className="panel-item-left">
                                            {tab.name}
                                        </span>
                                        {tab.key !== 'home' &&
                                            <span
                                                className="panel-item-right tab-close icon iconfont icon-shenpibohui"
                                                onClick={(e) => { this.handleTabClose(e, index) }}
                                            />
                                        }
                                    </div>
                                </NCTooltip>
                            })
                            }
                        </div>}
                    >
                        <span
                            fieldid="inside-tab-dropdown"
                            className={visible ? "drop-down-show" : ''}
                        >
                            <img
                                tabIndex="1"
                                className="drop-down"
                                src={dropIcon}
                            />
                        </span>
                    </NCDropdown>
                    {
                        !actived
                        &&
                        <NCTooltip overlay={
                            langCheck("browserTabs-0000010", true, this.state.json) /* 国际化处理： 桌面编辑*/
                        }
                        >
                            <i
                                fieldid="inside-tab-desksetting"
                                onClick={this.handleEditDesktop}
                                className="right-item icon iconfont icon-zhuomianpeizhi"
                            />
                        </NCTooltip>
                    }
                    <NCTooltip overlay={navShow ?
                        langCheck("browserTabs-0000011", true, this.state.json) /* 国际化处理：收起标签栏*/
                        :
                        langCheck("browserTabs-0000012", true, this.state.json) /* 国际化处理： 展示标签栏*/
                    }>
                        <i
                            fieldid="inside-tab-navfold"
                            className={`right-item icon iconfont icon-yincangdaohang ${navShow ? 'nav-icon' : 'nav-icon-rotate'}`}
                            onClick={() => { onTabChange('navShow') }}
                        />
                    </NCTooltip>
                    <NCTooltip overlay={isFullScreen ?
                        langCheck("browserTabs-0000013", true, this.state.json) /* 国际化处理： 退出全屏*/
                        :
                        langCheck("browserTabs-0000014", true, this.state.json) /* 国际化处理： 全屏显示*/
                    }>
                        <i
                            fieldid="inside-tab-fullscreen"
                            className={`right-item icon iconfont ${isFullScreen ? 'icon-tuichuquanping' : 'icon-quanpingliulan'}`}
                            onClick={this.toggleFullScreen}
                        />
                    </NCTooltip>
                </div>
            </div >
            {/* 渲染标签内容 */}
            {/* contentRef父组件有用到 */}
            <div className="content-wrapper" ref={ref => this.contentRef = ref}>
                {this.renderTabContent()}
            </div>

            {
                // 拖拽时遮罩，目的是盖住节点的iframe，不然拖拽至iframe时无响应
                tabDragging && <div
                    className="inside-tab-dragging"
                    onMouseUp={() => {
                        this.setState({
                            tabDragging: false
                        })
                    }}
                />
            }
            <NCLoading
                fullScreen
                showBackDrop={true}
                // loadingType="line"
                show={this.state.loading}
            />
        </React.Fragment>
    }
}

class MemoComponent extends Component {
    shouldComponentUpdate(nextProps) {
        const updateKeys = ['tabKey', 'appKey', 'hash', 'visible', 'isInsideTab'];
        return _.isEqualWith(nextProps, this.props, (newValue, oldValue) => {
            for (let k of updateKeys) {
                if (newValue[k] !== oldValue[k]) {
                    return true;
                }
            }
            return false;
        });
    }

    render() {
        const { appComponent: AppComponent, onRef, ...otherProps } = this.props;
        return <AppComponent ref={onRef} { ...otherProps } />
    }
}
class MemoChildren extends Component {
    shouldComponentUpdate(nextProps) {
        // 个性化设置从浏览器页签改为内部页签返回之后，pathname会改变
        return nextProps.children !== this.props.children || nextProps.location.pathname !== this.props.location.pathname;
    }

    render() {
        return this.props.children;
    }
}

export default BrowserTab